import { createStore, withProps } from '@ngneat/elf';
import { EmailTrace } from '@/types/email-trace.types';

export interface EmailTraceStateProps {
  response?: Partial<EmailTrace>;
  dto?: Partial<EmailTrace>;
  selectedEmailTrace?: EmailTrace;
}

export const emailTraceStateInitialState: EmailTraceStateProps = {
  response: {
    id: 0,
    type_email: '',
    objet: '',
    contenu: '',
    destinataire: '',
    successSend: false,
    dateSend: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
    isDeleted: false,
  },
  dto: {
    id: 0,
    type_email: '',
    objet: '',
    contenu: '',
    destinataire: '',
    successSend: false,
    dateSend: '',
    createdAt: '',
    createdBy: '',
    updatedAt: '',
    updatedBy: '',
    isDeleted: false,
  },
  selectedEmailTrace: undefined,
};

export const emailTraceStateStore = createStore({ name: 'email-trace-state' }, withProps<EmailTraceStateProps>(emailTraceStateInitialState));
